import { Autocomplete, TextField } from "@mui/material";

import { MODEL_PROPTYPES } from "../../../models";
import PropTypes from "prop-types";
import { applyPreset } from "../utils/preset";
import { useFormContext } from "react-hook-form";
import { useSnackbar } from "../../../hooks";
import { useState } from "react";

PresetSelect.propTypes = {
    presets: PropTypes.arrayOf(
        PropTypes.shape(MODEL_PROPTYPES.CropModulePreset)
    ),
    initialPreset: PropTypes.shape(MODEL_PROPTYPES.CropModulePreset),
    jobNameToModuleVersion: PropTypes.objectOf(
        PropTypes.shape(MODEL_PROPTYPES.ModuleVersion)
    ).isRequired,
    disabled: PropTypes.bool,
};

export function PresetSelect({
    presets,
    initialPreset,
    jobNameToModuleVersion,
    disabled,
}) {
    const [selectedPreset, setSelectedPreset] = useState(initialPreset ?? null);
    const { reset, getValues } = useFormContext();
    const { openSnackbar } = useSnackbar();

    const sortedPresets = [...(presets ?? [])].sort((a, b) =>
        a.name.localeCompare(b.name)
    );

    const handleChange = (_, newValue) => {
        setSelectedPreset(newValue);
        const newFormValues = applyPreset(
            newValue.values,
            getValues(),
            jobNameToModuleVersion
        );
        reset(newFormValues, { keepDefaultValues: true });
        openSnackbar(`Preset applied: ${newValue.name}`, "success");
    };

    return (
        <Autocomplete
            sx={{ width: 300 }}
            options={sortedPresets}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
            disableClearable
            value={selectedPreset}
            disabled={disabled}
            onChange={handleChange}
            renderInput={(params) => (
                <TextField {...params} label="Crop Preset" />
            )}
        />
    );
}
